// extracted by mini-css-extract-plugin
module.exports = {"item":"PrimaryLink_item__XEDre","active":"PrimaryLink_active__Pj7Nv"};